import { c as _c } from "react/compiler-runtime";
import type { CartItemInputDto } from "@sticker-giant/sg-frontend-common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { identifyReturningCustomer, trackItemAddedToCart } from "@/lib/analytics/segment";
import { commitCart } from "@/queries/useCart";
import { useGlobalStore } from "@/stores/useGlobalStore";
import { useNewCartStore } from "@/stores/useNewCartStore";
import { useServicesStore } from "@/stores/useServicesStore";
export const addToCartMutationKey = ["addToCart"] as const;
export const updateCartItemMutationKey = ["updateCartItem"] as const;
export interface Options {
  openCartOnSuccess?: boolean;
}
export function useCartMutation(isEditMode, t0) {
  const $ = _c(12);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    openCartOnSuccess: t2
  } = t1;
  const openCartOnSuccess = t2 === undefined ? true : t2;
  const queryClient = useQueryClient();
  const t3 = isEditMode ? updateCartItemMutationKey : addToCartMutationKey;
  let t4;
  if ($[2] !== isEditMode) {
    t4 = async item => {
      const {
        cartClient
      } = useServicesStore.getState();
      if (!cartClient) {
        throw new Error("Cart client is not available.");
      }
      return isEditMode ? cartClient.updateCartItem(item) : cartClient.addItemToCart(item);
    };
    $[2] = isEditMode;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isEditMode || $[5] !== openCartOnSuccess || $[6] !== queryClient) {
    t5 = response => {
      if (!response) {
        return;
      }
      commitCart(queryClient, response.cart);
      useGlobalStore.getState().setCartId(response.cart.id);
      identifyReturningCustomer(response.cart.customer.isReturningCustomer);
      trackItemAddedToCart({
        cartItemResponse: response,
        isEditMode
      });
      if (openCartOnSuccess) {
        useNewCartStore.getState().setIsCartOpen(true);
      }
    };
    $[4] = isEditMode;
    $[5] = openCartOnSuccess;
    $[6] = queryClient;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      mutationKey: t3,
      mutationFn: t4,
      onSuccess: t5
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return useMutation(t6);
}